export default {
  exhibition: {
    filterTitle: '类别筛选',
    companyTypeTitle: '公司类型',
    searchPlaceholder: '搜索产品',
    filterButton: '筛选',
    clearAll: '清空全部',
    categories: {
      literature: '文学、小说',
      humanities: '人文史地',
      socialScience: '社会科学',
      naturalScience: '自然科普',
      business: '商管理财',
      art: '艺术设计',
      selfHelp: '心灵励志',
      lifestyle: '实用生活',
      children: '儿童及青少年读物',
      language: '语言学习',
      comics: '绘本、漫画',
      exam: '考试用书',
      digital: '电子书和有声书',
      promotional: '宣传品',
      stationery: '文仪用品',
      others: '其他（请列明）'
    },
    title: '展区信息',
    location: '位置',
    time: '时间',
    description: '简介',
    exhibits: '展品',
    activities: '活动'
  },
  detail: {
    companyName: '公司名称',
    companyIntro: '公司介绍',
    companyType: '公司种类',
    contact: '联络',
    contactPerson: '公司商务/版权联络人姓名',
    position: '职位',
    email: '电邮',
    phone: '电话',
    fax: '传真',
    address: '通讯地址',
    website: '网页',
    moreProducts: '更多展品推荐',
    companyTypes: {
      publishing: '出版',
      printing: '印刷'
    }
  },
  footer: {
    copyright: '© 2025 香港书展 版权所有',
    disclaimer: '免责声明：在本刊物/活动内(或由项目小组成员)表达的任何意见、研究成果、结论或建议，均不代表香港特别行政区政府、文化体育及旅游局、文创产业发展处、"创意智优计划"秘书处或"创意智优计划"审核委员会的观点。'
  },
  nav: {
    home: '香港馆',
    exhibition: '展区',
    exhibits: '展品',
    exhibitors: '参展商名录',
    sponsors: '联络我们',
    comprehensive: '综合展区',
    award: '获奖作品展区',
    pictureBook: '绘本专区',
    creative: '创意区',
    heritage: '“漫步香港：非遗与城市记忆”区',
    organiser: '主办机构',
    CoOrganizers: '共同承办',
    Sponsors: '赞助机构',
    supportingOrganizers: '支持机构',
    themeExhibition: '主题展区：',
    ranking: '（排名不分先后）：',
    publications: '“漫步香港：非遗与城市记忆”',
    printing: '香港插画专区',
    artInstallationsAndCrafts: '香港作家掠影展区',
    officialWebsite: '香港馆官网',
    publicationsDesc: `此次香港馆特设主题展区，聚焦展示七项香港非物质文化遗产，呈现本地匠人对传统工艺的坚持与创新精神，体现优秀中华文化在香港的传承与创新。 展品涵盖“蒸笼制作技艺”、“花纽制作技艺”、“广彩制作技艺”、“粤剧头饰制作”、“扎作技艺”、“港式奶茶制作技艺”及“舞火龙”，涵盖香港传统手工艺与节庆民俗。观众可近距离欣赏以竹编成的点心蒸笼、精巧细致的长衫花钮、色彩斑斓的手绘广彩瓷器，以及闪烁耀目的粤剧头饰；亦可了解“舞火龙”的社区传统及背后仪式意涵，感受港式奶茶在日常饮食文化中的深厚底蕴。主题展区内亦展出相关图书及印刷品。`,
    printingDesc: `此次香港馆继续设有“香港插画专区”，展示入选第二届“《飞跃绘本》——香港绘本插画师国际书展推广计划”的八位香港新晋绘本插画师的作品，以及八本在“香港绘本出版支援计划”下出版的无字绘本。两项计划均由创意创业会主办、文化创意产业发展处资助。`,
    artInstallationsAndCraftsDesc: `此次香港馆特设“香港作家掠影展区”，展出逾70种由香港出版社出品的华语文学作品，包括：荣获第4届香港出版双年奖出版大奖及最佳出版奖（文学及小说类）由西西著作、何福仁主编的《动物嘉年华：西西的动物诗（中英双语版本）》；以及展出与香港有着颇深渊源的四位华语作家：叶灵凤、张爱玲、刘以鬯、西西，他们的30多件珍贵的手稿复制品和相关图片。 \n\n此展区亦是为2025年10月在香港举办的首届“世界华语文学节”预热宣传。 “世界华语文学节”希望打造全球华语文学的核心交流平台，推动香港成为世界华语文学之都，助力香港巩固发展中外文化艺术交流中心。`,
    all: '全部'
  },
  message: {
    noData: '暂无数据',
    contactUs: '联系我们',
    ProductDescription: '产品资讯',
    category: '类别',
    author: '作者',
    publishDate: '出版日期/印刷日期',
    type: '种类'
  },
  common: {
    loading: '加载中...',
    noData: '暂无数据',
    error: '出错了',
    retry: '重试'
  },
  home: {
    title: '2025年北京国际图书博览会香港馆',
    description: '香港特别行政区（香港特区）政府文创产业发展处于2025年6月18至22日首次主办北京国际图书博览会香港馆，以推广香港作为中外文化艺术交流中心，以及协助香港出版及印刷业开拓内地市场。项目由香港出版总会与香港印刷业商会共同承办，并获香港特区政府驻北京办事处、创意创业会、世界华语文学基金会、香港专业人员（北京）协会，以及香港印刷业商会属下的印刷科技研究中心担任支持机构。',
    description2: '此次香港馆的主题为“漫步香港：非遗与城市记忆”，在主题展区着重展现香港非物质文化遗产与城市记忆在交互辉映下，体现“以文塑旅，以旅彰文”，推动文化和旅游融合发展。',
    description3: '“北京国际图书博览会”作为国内最大及国际第二大的书展，对推动版权贸易有着举足轻重的角色。为协助香港出版及印刷业界进一步通过“北京国际图书博览会”，推广优秀的香港图书、印刷品及电子书，同时为配合香港特区政府公布的“文艺创意产业发展蓝图”，利用香港国际化的策展和创作技巧，推广中华传统优秀文化和香港独特文化，以及推动非物质文化遗产(非遗)的传承和转化创新，自2011年起已在“北京国际图书博览会”设立的“香港馆”将进行革新，除了改由文创产业发展处主办、香港出版总会承办外，计划邀请非物质遗产办公室、香港旅游业议会、文化葫芦等协办，更会加强“香港馆”的内容，设立特定主题以展示优秀的香港出版物、印刷品及相关展品，同时利用此平台，将香港独特文化展现给来自全国及世界各地的参展商及参观者，以进一步巩固香港作为“中外文化艺术交流中心”的地位。',
    viewMore: '进入香港馆'
  },
  ablout: {
    title1: '文创产业发展处',
    title2: '香港出版总会',
    title3: '香港印刷业商会',
    website: '网址',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    address1: '香港湾仔告士打道5号税务大楼四十楼',
    address2: '香港北角英皇道75-83号联合出版大厦26楼',
    address3: '香港湾仔庄士敦道48-50号二楼'
  }
}
